import { useEffect, useState } from "react";
import styles from "./reset-password-page.module.css";
import { useAuth } from "BEDROCK/auth/supabase-auth";
import { CTAButton } from "BEDROCK/shared-components/cta-button";
import { usePaths } from "BEDROCK/paths";
import { TextField as Input } from "BEDROCK/shared-components/textfield";
import { isPasswordValid } from "BEDROCK/utility/validators/form-validation";

interface ResetPasswordPageProps {}

export const ResetPasswordPage = (props: ResetPasswordPageProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <div className={styles.header}>
          <div className={styles.headerContent}>
            <h1>Reset password</h1>
            <ResetPasswordSection />
          </div>
        </div>
      </div>
    </div>
  );
};

interface ResetPasswordSectionProps {}

const ResetPasswordSection = (props: ResetPasswordSectionProps) => {
  const { changePassword } = useAuth();
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");

  const [canSave, setCanSave] = useState(false);

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);

  useEffect(() => {
    const match = newPassword === newPasswordConfirm;
    const isValid = isPasswordValid(newPassword);
    setCanSave(isValid && match);
  }, [newPassword, newPasswordConfirm]);

  const mismatch =
    newPassword.length > 0 ||
    (newPasswordConfirm.length > 0 && newPassword !== newPasswordConfirm);

  if (success) {
    return (
      <div className={styles.section}>
        <div className={styles.leadingContent}>
          <h2>Password changed</h2>
          <p>Your password has been changed successfully.</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.section}>
        <div className={styles.leadingContent}>
          <h2>Password change failed</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.section}>
      <Input
        placeholder="New password"
        value={newPassword}
        onChangeText={setNewPassword}
        type="password"
      />
      <Input
        placeholder="Confirm new password"
        value={newPasswordConfirm}
        onChangeText={setNewPasswordConfirm}
        type="password"
      />
      <div className={styles.ctaContainer}>
        <CTAButton
          title="Save"
          disabled={!canSave}
          variant="SECONDARY"
          onClick={() => {
            changePassword(newPassword)
              .then(() => {
                setSuccess(true);
              })
              .catch((error) => {
                console.log("Error changing password:", error);

                if (error.name === "AuthApiError") {
                  if (
                    error.message.includes("New password should be different")
                  ) {
                    // Handle specific message
                    setError(
                      "You must choose a different password from your current one."
                    );
                  } else {
                    setError("An authentication error occurred.");
                  }
                } else {
                  setError("Something went wrong.");
                }
              });
          }}
        />
      </div>
    </div>
  );
};
